import { Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { checkAccessFn } from "../utils/checkAccess";

const CheckAccess = ({ children, module, name }) => {
    const dashboardData = useSelector((state) => state.dashboardData);
    const checkAccess = (module, name) => checkAccessFn(dashboardData, module, name);

    if (dashboardData.isloading) return null; // Or a loading spinner
    if (!dashboardData.data) return null; // Wait for data to be present

    if (!checkAccess(module, name)) return <Navigate to='/dashboard' />
    return children;
}

export default CheckAccess;